import StorageManager from '../jscontrol/StorageManager';
import { getApiBaseUrl, getImageSrc } from '../../utils/appConfig';

export { getImageSrc };
export const getApiBase = () => getApiBaseUrl();

export const getAddBannerId = (item) => item?.AddBannerId ?? item?.addBannerId;

/** AddBanner API expects CreatedBy/UpdatedBy as string (unlike Banner int). */
export const getAddBannerAuditUser = () => {
  const userId = StorageManager.userId();
  const username = StorageManager.username();
  if (userId != null && userId !== '') return String(userId);
  if (username) return String(username);
  return '0';
};

export const parseUploadImageUrl = (json) => {
  if (!json) return '';
  if (typeof json === 'string') return json;
  const d = json.data ?? json.Data;
  const candidates = [
    json.imageUrl,
    json.ImageUrl,
    json.url,
    json.Url,
    json.path,
    json.Path,
    typeof d === 'string' ? d : null,
    d?.imageUrl,
    d?.ImageUrl,
    d?.url,
    d?.Url,
    json.result,
    json.Result,
  ];
  return candidates.find((v) => typeof v === 'string' && v.trim()) || '';
};
